module.exports = __webpack_public_path__ + "fonts/Quarca-NorReg.0c202748.woff2";